(function () {
    'use strict';

    angular
        .module('franchiser.services')
        .service('PaymentSlipRemittanceService', PaymentSlipRemittanceService)

    /** @ngInject */
    function PaymentSlipRemittanceService(HttpService) {
        const PaymentSlipRemittanceService = {
            getByParameters,
            get,
            save,
            delete: deletePaymentRemittance
        }

        return PaymentSlipRemittanceService;

        function getByParameters(params) {
            return HttpService.get('/payment/remittances/by-parameters', {
                params
            });
        }

        function get(paymentRemittanceId) {
            return HttpService.get(`/payment/remittances/${paymentRemittanceId}`);
        }

        function save(paymentRemittanceData) {
            return HttpService.post('/payment/remittances', paymentRemittanceData);
        }

        function deletePaymentRemittance(paymentRemittanceId) {
            return HttpService.delete(`/payment/remittances/${paymentRemittanceId}`);
        }
    }
}());